export default __webpack_public_path__ + "static/media/9b0c34373a5f2360.4d105cb353ca5cdcb89977c3ad528dec.svg";